import moment from 'moment/moment';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Alert, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Nav } from 'reactstrap';
import trainingPhasesActionCreators from '../../store/training-phases/action-creators/index';
import ReportTable from './PhaseReportTable';
import LoadingButton from '../../../shared/ui/LoadingButton';

class OrientationPhaseDetail extends Component {
  constructor(props) {
    super(props);
    this.state = { dropdownOpen: false };
  }

  // ----------------------
  // Handlers
  // ----------------------

  onAddReport(type) {
    const getResponses = () => {
      if (['dor', 'eop', 'wor'].includes(type)) {
        return [{ datetime: moment().toISOString(), sequence: 0 }];
      }
      return [];
    };
    const formData = {
      formType: type,
      responses: getResponses(),
      trainingPhaseGuid: this.props.phaseGuid || this.props.selectedPhaseGuid,
    };
    this.props.createReport(formData)
      .then(reportGuid => this.props.editReport(reportGuid));
  }

  // ----------------------
  // Computed
  // ----------------------

  get hasOrientationReport() {
    return !this.props.phase ? false
      : !!this.props.phase.accrued.find(report => report.type === 'tpo');
  }

  get showAddActionButton() {
    return this.props.phase.status === 'opened' && this.props.userContext.hasScope(['oit']);
  }

  // ----------------------
  // Methods
  // ----------------------

  toggleDropdown() {
    this.setState({ dropdownOpen: !this.state.dropdownOpen });
  }

  // ----------------------
  // Render
  // ----------------------

  render() {

    return (
      <Fragment>
        <div>
          {this.showAddActionButton &&
            <Nav className="justify-content-end">
              <Dropdown isOpen={this.state.dropdownOpen} nav toggle={() => this.toggleDropdown()}>
                <DropdownToggle className="dropdown-icon" nav>
                  <LoadingButton
                    primary
                    small
                    text="Add report"
                    icon="fa fa-plus"
                  />
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem onClick={() => this.onAddReport('tpo')}>Add Orientation</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </Nav>
          }
          {!this.props.reports ? (
            <Alert color="primary">No reports found for Training Phase</Alert>
          ) : (
            <ReportTable phase={this.props.phase} reports={this.props.reports} />
          )}
        </div>
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    reports: state.trainingPhases.reports,
    selectedPhaseGuid: state.trainingPhases.selectedGuid,
    userContext: state.common.userContext,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addReport: (type) => {
      return dispatch(trainingPhasesActionCreators.addReport(type));
    },
    createReport: (formData) => {
      return dispatch(trainingPhasesActionCreators.createReport(formData));
    },
    editReport: (reportGuid) => {
      return dispatch(trainingPhasesActionCreators.editReport(reportGuid));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrientationPhaseDetail);
